module.exports = __webpack_public_path__ + "img/ic-scroll-down.svg";